module.exports = __webpack_public_path__ + "img/icon_map_10_off_100.c4e51888.png";